import { OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { AppStateFacade } from '@app-state';
import { TranslateService } from '@ngx-translate/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export class UiMatPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
    public firstPageLabel = '';
    public lastPageLabel = '';
    public itemsPerPageLabel = '';
    public nextPageLabel = '';
    public previousPageLabel = '';

    private _firstPageLabelKey = 'paginator_first_page';
    private _lastPageLabelKey = 'paginator_last_page';
    private _itemsPerPageLabelKey = 'grid_items';
    private _nextPageLabelKey = 'paginator_next_page';
    private _previousPageLabelKey = 'paginator_previous_page';

    private _destroyed$ = new Subject();

    constructor(
        private _translateService: TranslateService,
        appState: AppStateFacade,
    ) {
        super();
        appState.language.value$
            .pipe(
                takeUntil(this._destroyed$),
            )
            .subscribe(this._setTranslations);
    }

    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();

        this.changes.complete();
    }

    public getRangeLabel = function (page: number, pageSize: number, length: number) {
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        return startIndex + 1 + ' - ' + endIndex + ' / ' + length;
    };

    private _setTranslations = () => {
        this.firstPageLabel = this._translateService.instant(this._firstPageLabelKey);
        this.lastPageLabel = this._translateService.instant(this._lastPageLabelKey);
        this.itemsPerPageLabel = this._translateService.instant(this._itemsPerPageLabelKey);
        this.nextPageLabel = this._translateService.instant(this._nextPageLabelKey);
        this.previousPageLabel = this._translateService.instant(this._previousPageLabelKey);

        this.changes.next();
    }
}
